var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illustration / 11",
    clipPath: "url(#pi0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shadow",
    opacity: 0.2,
    filter: "url(#pi-filter0_f)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 22,
    fill: "#053668"
  })), /*#__PURE__*/React.createElement("path", {
    id: "form",
    d: "M28.7806 4.93802L4 24V54C4 55.1046 4.89543 56 6 56H54C55.1046 56 56 55.1046 56 54V24L31.2194 4.93802C30.5005 4.38501 29.4995 4.38501 28.7806 4.93802Z",
    fill: "#1573DA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "letter",
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.00098,
    y: 8.00049,
    width: 42,
    height: 40,
    rx: 1,
    fill: "url(#pi-paint0_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "front",
    d: "M4 24V54C4 55.1046 4.89543 56 6 56H54C55.1046 56 56 55.1046 56 54V24L37 42H23L4 24Z",
    fill: "url(#pi-paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bottom",
    d: "M37 42L53.5503 54.1949C54.3274 54.7676 53.9224 56 52.9571 56H7.04292C6.07761 56 5.67259 54.7676 6.44972 54.1949L23 42H37Z",
    fill: "url(#pi-paint2_linear)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "arrows"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0303 20.4698L26.5 16.9395L22.9697 20.4698C22.6768 20.7627 22.6768 21.2375 22.9697 21.5304C23.2626 21.8233 23.7374 21.8233 24.0303 21.5304L25.75 19.8108V28.0001C25.75 28.4143 26.0858 28.7501 26.5 28.7501C26.9142 28.7501 27.25 28.4143 27.25 28.0001V19.8108L28.9697 21.5304C29.2626 21.8233 29.7374 21.8233 30.0303 21.5304C30.3232 21.2375 30.3232 20.7627 30.0303 20.4698Z",
    fill: "#3F4F68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0303 27.5302L33.5 31.0605L29.9697 27.5302C29.6768 27.2373 29.6768 26.7625 29.9697 26.4696C30.2626 26.1767 30.7374 26.1767 31.0303 26.4696L32.75 28.1892V19.9999C32.75 19.5857 33.0858 19.2499 33.5 19.2499C33.9142 19.2499 34.25 19.5857 34.25 19.9999V28.1892L35.9697 26.4696C36.2626 26.1767 36.7374 26.1767 37.0303 26.4696C37.3232 26.7625 37.3232 27.2373 37.0303 27.5302Z",
    fill: "#3F4F68"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pi-filter0_f",
    x: -16,
    y: -16,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 8.50098,
    y: 7.50049,
    width: 44,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pi-paint0_linear",
    x1: 30.001,
    y1: 8.00049,
    x2: 30.001,
    y2: 48.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pi-paint1_linear",
    x1: 30,
    y1: 24,
    x2: 30,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25ABF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E95F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pi-paint2_linear",
    x1: 30,
    y1: 42,
    x2: 30,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1878C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E94F7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pi0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiveIcon);
export default __webpack_public_path__ + "static/media/receive-icon.72a4abca.svg";
export { ForwardRef as ReactComponent };